<template>
  <div style="margin-bottom:50px">
    <van-row v-if="classList.length > 0 && getTokenType()">
      <van-col
        @click="getgroupList(item)"
        :span="24"
        class="bg-white m-t-06"
        style="border-radius: 0.3rem;padding-bottom:0.5rem"
        v-for="(item, index) in classList"
        :key="index"
      >
        <div class="text-r">
          <van-tag
            type="warning"
            color="#FFF4EC"
            text-color="#F67F28"
            class="tag f-s-6"
            style="height:1rem"
            >{{ item.course_content }}</van-tag
          >
        </div>
        <van-row style="padding-left:0.75rem;padding-right:0.75rem">
          <div class="van-multi-ellipsis--l2">
            <span class="f-s-16" style="color:#292E35;font-weight: 600;">
              {{ item.ctitle }}
            </span>
          </div>
          <p class="f-s-6 m-t-04" style="color:#657081">
            课程有效期截止：{{ item.orderEndDate }}
          </p>
        </van-row>
      </van-col>
    </van-row>
    <NoData v-else text="您还没有购买课程,先去看看优质课程吧" path="/" :empty="empty"  />
    <Agreement ref="agreement" :cid="cid" />

  </div>
</template>

<script>
import Agreement from "@/components/common/agreement/agreement"
export default {
  props: {
    classList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components:{
    Agreement
  },
  data() {
    return {
      empty:require("@/assets/imgs/empty/noClass.png"),
      cid : ""
    };
  },
  methods: {
    getgroupList(item) {
      let data = {
        cid : item.cid,
        uid : this.uid()
      }
      this.ApiNew.Mine.userIfSignAgreement(data).then(res => {
        if(res.retuCode == 5000) {
          this.$router.push({
            path: "/chapter",
            query: {
              cid: item.cid,
            },
          });
        } else if(res.retuCode == 5028 || res.retuCode == 5025) { // 用户未签署协议
          this.cid = item.cid
          this.$refs.agreement.agreementName = res.data.name
          this.$refs.agreement.agreementId = res.data.agreementid
          this.$refs.agreement.show = true
        }
      }).catch(() => {
        this.$router.push({
            path: "/chapter",
            query: {
              cid: item.cid,
            },
          });
      })
    },
  },
};
</script>

<style lang="less" scoped>
.tag {
  width: 2rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  height: 0.6rem;
  border-top-left-radius: 0.55rem;
  border-bottom-left-radius: 0.55rem;
  // padding-top: 0.2rem;
  // padding-bottom: 0.2rem;
}
.bodyTag {
  width: 1.6rem;
  height: 0.9rem;
}
</style>
